import { findInboxMessagesByCriteria } from '@src/main/modules/messages/application/use-cases/find/find-inbox-messages-by-criteria.usecase';
import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { InboxMessageRepository } from '@src/main/modules/messages/domain/message/inbox/inbox-message.repository';
import { useQuery } from '@tanstack/react-query';

export const useInboxMessages = (
  repository: InboxMessageRepository | null,
  criteria: InboxMessageCriteria,
) =>
  useQuery({
    queryKey: ['inboxMessages', criteria],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findInboxMessagesByCriteria(repository, criteria);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });
